import moment from "moment";

export default function dateToTime(date: any): string {
    return moment(date).format("HH:mm");
}
